import { SIGN_UP, LOADING } from './types';

let initialState = {
    data: {},
    loading: false,
    error: null
};

export const auth = (state = initialState, action) => {
    switch (action.type) {
        case SIGN_UP:
            return { ...state, data: action.data };
        case LOADING:
            return { ...state, loading: action.loading };
        default:
            return state;
    }
};
